import { createFileRoute } from "@tanstack/react-router";

import { apiUtils } from "@/context/query";

export const Route = createFileRoute("/_auth/_app")({
  beforeLoad: async () => {
    const views = await apiUtils.accession.views.list.ensureData();

    return { views };
  },
});
